import { Component, ElementRef, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import * as _ from "lodash";
import { CommonServices } from "src/app/common.services";
import { TripsDetailsComponent } from "src/app/customer/trips-details/trips-details.component";
import { WindowRefService } from "src/app/window-ref.service";
import { CorporateTripsDetailsComponent } from "../corporate-trips-details/corporate-trips-details.component";
import { CorporateService } from "../corporate.service";
import { environment } from "src/environments/environment";
import { Subscription } from "rxjs";
import { MapGeocoder } from "@angular/google-maps";
declare var $: any;

@Component({
  selector: "app-corporate-trips",
  templateUrl: "./corporate-trips.component.html",
  styleUrls: ["./corporate-trips.component.css"],
})
export class CorporateTripsComponent implements OnInit {
  matDialogref: MatDialogRef<CorporateTripsDetailsComponent> | undefined;
  trips_track: boolean = true;
  tripType: any = "All";
  live_track: boolean = false;
  fetch_page: any = 1;
  currentPage: any = 1;
  startPage: any = 1;
  last_page: any = 1;
  document_array: any = [];
  zoom = 7;
  customerOtp: boolean = false;
  tripNumber: any = -1;
  token: any;
  tripArray: any = [];
  center: google.maps.LatLngLiteral = { lat: 21.14, lng: 79.08 };
  selTripDetails: any;
  trips: any;
  customerCode: any;
  latlngArray: any = [];
  startLoc: any = {};
  endLoc: any = {};
  curLoc: any = {};
  trackTimerObj: any;
  trackArray: any = [];
  customerArray: any = [];
  corporateArray: any = [];
  MatDialogref: MatDialogRef<TripsDetailsComponent> | undefined;
  viewTripIndex: number = 0;
  cancelTripIndex: number = 0;
  cancelTrip: boolean = false;
  cancelButton: boolean = true;
  payNowTripIndex: number = 0;
  loading: boolean = false;
  paynowAmt: any;
  totalAmount: any;
  tax_details: any = [];
  profileDetails: any;
  paymentResponse: any;
  taxDetails: any;
  refundAmount: number = 0;
  otherTrips: boolean = false;
  transporterTrips: boolean = false;
  cancelReasonForm!: FormGroup;
  searchButton: boolean = true;
  search_Btn: boolean = false;
  toggleSearch: boolean = false;
  cancelSearchButton: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;
  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;
  @Input() item: string;
  tripsloading: boolean = false;
  flattenedArray: any[] = [];
  intervalId: any;
  corporate_map: boolean = false;
  truck_array: any = [];
  data: any;
  private subscription: Subscription | undefined;
  isFirstCall: boolean = true;
  isLoading: boolean = false;
  isFullTrackingLoading: boolean = false;
  showFullTracking: boolean = false;
  fullTrackData: any = null;
  constructor(
    private router: Router,
    private matDialog: MatDialog,
    private services: CorporateService,
    private snackBar: MatSnackBar,
    private commonService: CommonServices,
    private windowRef: WindowRefService,
    private geocoder: MapGeocoder
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("corporate_token");
    this.getTripsDetails(this.tripType, this.tripNumber);
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
  }

  getTripsList(selectedTripType: any) {
    this.tripType = selectedTripType;
    this.fetch_page = 1;
    this.currentPage = 1;
    this.startPage = 1;
    this.document_array = [];
    this.getTripsDetails(this.tripType, this.tripNumber);
  }

  getTripsDetails(tripType: any, type: any) {
    this.tripsloading = true;
    this.tripNumber = type;
    this.services
      .getTripList(this.token, this.startPage, tripType, this.tripNumber)
      .subscribe(
        (response: any) => {
          this.tripsloading = false;
          this.corporateArray = [];
          this.customerArray = [];
          this.tripArray = response.body?.data || [];
          this.tripArray.forEach((element: any) => {
            if (element.userInfo?.user_type === "corporate") {
              this.corporateArray.push(element);
            } else if (element.userInfo?.user_type === "customer") {
              this.customerArray.push(element);
            }
          });

          if (response.body?.meta) {
            this.document_array.push(response.body.meta);
            this.last_page = response.body.meta.lastPage || 1;
          } else {
            this.last_page = 1;
          }
          for (let i = 0; i < this.tripArray.length; i++) {
            if (
              this.tripArray[i].trip_status === "tripbooked" ||
              "tripstarted" ||
              "inprogress"
            ) {
              this.live_track = true;
            }
          }
        },

        (error) => {
          this.corporateArray = [];
          this.customerArray = [];
          this.tripsloading = false;
          if (error.status == 404) {
            this.last_page = 1;
            return;
          }
          if (error.status === 401) {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            window.localStorage.clear();
          }
          this.tripArray = [];
          this.corporateArray = [];
          this.customerArray = [];
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  GoToDashboard() {
    this.router.navigateByUrl("/corporate/dashboard");
  }

  GoToBookATrips() {
    this.router.navigateByUrl("/corporate");
  }

  GoToTrips() {
    location.reload();
    this.router.navigateByUrl("/corporate/trips");
  }

  GoTOWorkOrders() {
    this.router.navigateByUrl("/corporate/work-order-list");
  }

  GoToLedger() {
    this.router.navigateByUrl("/corporate/ledger");
  }

  clearAllIntervals() {
    const interval_id = window.setInterval(function () { },
      Number.MAX_SAFE_INTEGER);
    for (let i = 1; i < interval_id; i++) {
      window.clearInterval(i);
    }
  }

  ngOnDestroy(): void {
    this.clearAllIntervals();
    this.subscription?.unsubscribe();
  }

  liveTrack(item: any) {
    this.selTripDetails = this.tripArray.find((trip: any) => trip._id === item);
    this.isLoading = true;
    this.curLoc = [];
    this.trips_track = false;
    this.corporate_map = true;
    this.showFullTracking = false;
    this.isFullTrackingLoading = true;
    this.fullTrackData = null;
    this.trackArray = this.selTripDetails;
    this.data = null;

    // Clear any existing interval before starting a new one
    if (this.trackTimerObj) {
      clearInterval(this.trackTimerObj);
    }

    // Call latest location to get the fast response (one time only)
    this.services.latestLocation(this.token, item).subscribe(
      (res: any) => {
         if (!this.showFullTracking) {
             this.isLoading = false;
             this.processLocationData(res.body.data);
         }
      },
      (error) => {
         this.isLoading = false;
         this.handleTrackingError(error);
      }
    );

    // Initial fetch for full tracking in background (no polling yet)
    this.services.tracking(this.token, item).subscribe(
      (response: any) => {
         this.isFullTrackingLoading = false;
         this.fullTrackData = response.body.data;
         if (this.showFullTracking) {
             this.processLocationData(this.fullTrackData, true);
         }
      },
      (error) => {
         this.isFullTrackingLoading = false;
         this.handleTrackingError(error);
      }
    );
  }

  viewFullTracking() {
    this.showFullTracking = true;
    if (this.fullTrackData) {
      this.processLocationData(this.fullTrackData);
    } else {
      this.isLoading = true; // Wait for the background call to finish
    }

    // Start polling the polylines API every 10 secs now that the button was clicked
    if (this.trackTimerObj) {
      clearInterval(this.trackTimerObj);
    }

    const tripId = this.selTripDetails?._id;
    if (tripId) {
      const fetchFullTrackingData = () => {
        this.services.tracking(this.token, tripId).subscribe(
          (response: any) => {
             this.fullTrackData = response.body.data;
             if (this.showFullTracking) {
                 this.processLocationData(this.fullTrackData, true);
             }
          },
          (error) => {
             this.handleTrackingError(error);
          }
        );
      };

      // 2nd call immediately after the click
      fetchFullTrackingData();

      // Then continue polling every 10 secs
      this.trackTimerObj = setInterval(fetchFullTrackingData, 10000);
    }
  }

  handleTrackingError(error: any) {
    this.isLoading = false;
    if (
      error?.error?.message === "jwt malformed" ||
      error?.error?.message === "jwt expired"
    ) {
      this.router.navigateByUrl("/");
      window.localStorage.clear();
    }
    if (error?.error?.message) {
      this.snackBar.open(error.error.message, "Fail", {
        duration: 5000,
      });
    }
  }

  processLocationData(dataObj: any, isFullTracking = false) {
    if (isFullTracking && this.trackArray) {
      // Only merge the location arrays to refresh "Location" and "Last Updated Date",
      // preserving the rich Truck/Owner details loaded from the latest-location API.
      this.trackArray.truckLocInfo = dataObj?.truckLocInfo || dataObj?.truckLocation;
      this.trackArray.truckLocation = dataObj?.truckLocation || dataObj?.truckLocInfo;
      this.trackArray.routeSegments = dataObj?.routeSegments || [];
    } else if (dataObj) {
      this.trackArray = dataObj;
    }
    
    const locArray = this.trackArray?.truckLocInfo || this.trackArray?.truckLocation;
    if (!locArray?.length) return;

    let locations = locArray.flat(Infinity);
    
    // Always point `data` to the absolute latest location entry in the flattened array,
    // so the UI correctly shows the absolute last time the device pinged.
    this.data = locations[locations.length - 1] || {};
    this.customerOtp = this.trackArray.customerCode?.code != null;

    // Removed api_type filtering to allow all sources (mobile, simbased, interpolated) to be plotted sequentially

    const existingKeys = new Set();
    this.curLoc = locations
      .map((loc: any) => ({
        ...loc,
        lat: Number(loc.latitude),
        lng: Number(loc.longitude),
      }))
      .filter((loc: any) => {
        if (!loc.lat || !loc.lng || isNaN(loc.lat) || isNaN(loc.lng) || loc.lat === 0 || loc.lng === 0) {
          return false;
        }
        const key = `${loc.lat},${loc.lng}`;
        if (existingKeys.has(key)) {
          return false;
        }
        existingKeys.add(key);
        return true;
      });

    this.startLoc = {
      lat: this.trackArray.pickup_details?.from_lat,
      lng: this.trackArray.pickup_details?.from_long,
    };
    this.endLoc = {
      lat: this.trackArray.dropoff_details?.to_lat,
      lng: this.trackArray.dropoff_details?.to_long,
    };

    if ((!this.data.address || String(this.data.address).toLowerCase() === 'unknown') && this.data.latitude && this.data.longitude) {
      this.geocoder
        .geocode({
          location: {
            lat: Number(this.data.latitude),
            lng: Number(this.data.longitude),
          },
        })
        .subscribe(({ results }) => {
          if (results && results.length) {
            this.data.address = results[0].formatted_address;
          }
        });
    }
  }

  closeTracking() {
    this.trips_track = true;
    this.corporate_map = false;
    this.curLoc = { lat: 0, lng: 0 };
    this.trackArray = null;
    this.data = null;
    this.clearAllIntervals();
  }

  vertices: google.maps.LatLngLiteral[] = this.latlngArray;

  pagination(page_status: any) {
    let current = parseInt(this.currentPage) || 1;
    let newPage = current;

    if (page_status === "-1" || page_status === -1) {
      newPage = Math.max(1, current - 1);
    } else if (page_status === "1") {
      newPage = Math.min(this.last_page || 1, current + 1);
    } else if (page_status === "first") {
      newPage = 1;
    } else if (page_status === "last") {
      newPage = this.last_page || 1;
    } else {
      let parsed = parseInt(page_status);
      if (!isNaN(parsed)) {
        newPage = Math.max(1, Math.min(this.last_page || 1, parsed));
      }
    }

    if (newPage === current && (page_status === "-1" || page_status === "1")) {
      return;
    }

    this.currentPage = newPage;
    this.fetch_page = newPage;
    this.startPage = newPage;
    this.getTripsDetails(this.tripType, this.tripNumber);
  }

  viewTrips(item: any) {
    this.matDialogref = this.matDialog.open(CorporateTripsDetailsComponent, {
      width: "100%",
      maxHeight: "80vh",
      data: item,
      autoFocus: false,
    });
  }
  mapClick(item: any) {
    const locs = item?.truckLocInfo || item?.truckLocation;
    this.data = locs?.[locs.length - 1] || {};
    this.truck_array = item;

    // $("#myModal").modal("show");
    // Show the modal
    this.showModal();
  }

  // Use Angular's method to show the modal
  showModal() {
    const modal = document.getElementById("myModal");
    if (modal) {
      modal.style.display = "block";
    }
  }

  closeModel() {
    const modal = document.getElementById("myModal");
    if (modal) {
      modal.style.display = "none";
    }
  }

  openModal(item: any) {
    this.showModal();
  }

  marker(item: any) {}
  // closeModel() {
  //   $("#myModal").modal("hide");
  // }
  GoToTripDetails(item: any) {
    if (item.trip_status == "quote") {
      this.snackBar.open(
        "Trip has not been assigned yet please try after sometime",
        "Success",
        {
          duration: 5000,
        }
      );
    } else {
      this.viewTripIndex = item;
      this.MatDialogref = this.matDialog.open(TripsDetailsComponent, {
        width: "100%",
        maxHeight: "80vh",
        data: item,
        autoFocus: false,
      });
    }
  }
  GoToCancelTrip(index: number, status: string) {
    this.cancelTripIndex = index;

    if (status == "cancelled") {
      this.snackBar.open("This Trip is already Cancelled", "Fail", {
        duration: 5000,
      });
      return;
    }
    this.cancelTrip = true;
  }

  close() {
    this.cancelTrip = false;
  }

  getProfile() {
    this.services.GetProfile(this.token).subscribe(
      (profileRes: any) => {
        this.profileDetails = profileRes.body.data;
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  payBalance(i: number, tripsItem: any, item: any) {
    this.loading = true;
    this.close();
    this.payNowTripIndex = i;
    let balance =
      tripsItem.price_details?.total_amount -
      tripsItem.price_details?.amount_paid;
    let data = {
      trip_id: item._id,
      remaining_amount: Number(balance),
    };
    this.services
      .GeneratePaymentOrder(data, this.token)
      .subscribe((response: any) => {
        if (response.status === 201) {
          this.onlinePayment(response, this.token, item);
        }
        this.loading = false;
        this.getTripsDetails(this.tripType, this.tripNumber);
      });
  }
  payNow(i: number, tripsItem: any, item: any) {
    this.loading = true;
    this.payNowTripIndex = i;
    let balance = tripsItem.price_details?.amount_paid;
    let data = {
      trip_id: item._id,
      amount: balance,
    };
    this.services
      .GeneratePaymentOrder(data, this.token)
      .subscribe((response: any) => {
        if (response.status === 200) {
          const paymentData = {
            price_details: {
              actual_price: tripsItem.price_details?.amount_paid,
              total_amount: this.totalAmount,
              amount_paid: this.paynowAmt,
              tax_details: this.tax_details,
            },
          };

          this.services
            .TripPayment(paymentData, response.body.data._id, this.token)
            .subscribe((res: any) => {
              this.onlinePayment(res, this.token, response);
              this.loading = false;
            });
        }
        this.loading = false;
      });
  }
  onlinePayment(res: any, token: any, tripBookingResponse: any) {
    this.getProfile();
    var options = {
      key: environment.razorpay_key, // Enter the Key ID generated from the Dashboard
      amount: this.paynowAmt * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: "INR",
      name: "S9trucks",
      description: "Initial payment is happening which is 10%",
      image:
        "https://s9trucks.s3.us-east-2.amazonaws.com/1660327946469%20-%20S9256.png",
      order_id: res.body.data.id,
      handler: (response: any) => {
        const payload = {
          success: {
            razorpay_payment_id: response.razorpay_payment_id,
            order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
          },
          paymentStatus: "fully-paid",
        };
        this.services
          .updatePaymentResponse(token, payload, tripBookingResponse.payment_id)
          .subscribe((payResponse: any) => {
            if (payResponse) {
              this.paymentResponse = payResponse.body.data;
              window.location.reload();
            }
            this.commonService.publishMessage(
              "tripAssigned",
              tripBookingResponse.body.data
            );
            this.router.navigate(["/trips"]);
          });
      },
      prefill: {
        name: this.profileDetails.username,
        email: this.profileDetails.email ? this.profileDetails.email : "",
        contact: this.profileDetails.mobile,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#f25510",
      },
    };
    var rzp1 = new this.windowRef.nativeWindow.Razorpay(options);
    rzp1.open();
    rzp1.on("payment.failed", (errorResponse: any) => {
      const payload = {
        failure: {
          code: errorResponse.error.code,
          description: errorResponse.error.description,
          reason: errorResponse.error.reason,
          order_id: errorResponse.error.metadata.order_id,
          razorpay_payment_id: errorResponse.error.metadata.payment_id,
        },
        paymentStatus: "failed",
      };
      this.services
        .updatePaymentResponse(token, payload, res.body.paymentInfo._id)
        .subscribe((payResponse: any) => {
          this.router.navigate(["/trips"]);
        });
    });
  }
  consignNote(item: any) {
    window.open(item.consignment_details?.consignment_url, "_blank");
  }
  public GetTaxDetails() {
    var price =
      this.trips[this.cancelTripIndex].payment_details[0].price_details
        .actual_price;
    this.refundAmount = price;
    this.services.GetTaxdetails().subscribe((response: any) => {
      this.taxDetails = response.body.data;
      this.taxDetails.forEach((ele: any) => {
        ele.tax_amount = price * (ele.tax_amount.replace("%", "") / 100);
        this.refundAmount -= ele.tax_amount;
      });
    });
  }
  others() {
    this.otherTrips = true;
    this.transporterTrips = false;
  }
  transporter() {
    this.transporterTrips = true;
    this.otherTrips = false;
  }
  cancel() {
    this.otherTrips = false;
    this.transporterTrips = false;
  }
  tripCancel(item: any) {
    let reasonSelected = "";
    let reasonDisc = "";
    if (this.transporterTrips) {
      reasonSelected = "I have a better deal from other website or transporter";
      reasonDisc = this.cancelReasonForm.value.transportDetails;
    } else if (this.otherTrips) {
      reasonSelected = "others";
      reasonDisc = this.cancelReasonForm.value.otherDetails;
    } else {
      reasonSelected = "My trip as been postponed or cancelled";
    }

    const tripData = {
      reason: reasonSelected,
      description: reasonDisc,
    };
    this.services.cancellationTrip(item, tripData, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.cancelTrip = false;
          this.trips.splice(this.cancelTripIndex, 1);
          this.snackBar.open("Trip Cancellation Success", "Success", {
            duration: 5000,
          });
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  onInputChange(input: HTMLInputElement) {
    const value = input.value;
    this.previousValue = value;

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.previousValue = input.value;
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (this.cancelSearchButton) {
      this.search_Btn = true;
      this.cancelSearchButton = false;
    }

    this.isInputValid = value.trim().length >= 3;

    if (value.length === 0) {
      if (this.tripNumber !== -1) {
        this.callApi();
      }
    }
  }

  private callApi() {
    this.tripNumber = -1;
    this.fetch_page = 1;
    this.currentPage = 1;
    this.startPage = 1;
    this.getTripsDetails(this.tripType, this.tripNumber);
  }

  cancelSearch() {
    this.toggleSearch = false;
    this.cancelSearchButton = false;
    this.searchButton = true;
    this.isInputValid = false;
    this.previousValue = "";
    this.tripNumber = -1;
    this.fetch_page = 1;
    this.currentPage = 1;
    this.startPage = 1;
    this.getTripsDetails(this.tripType, this.tripNumber);
  }

  openSearch() {
    this.searchButton = false;
    this.cancelSearchButton = false;
    this.toggleSearch = true;
    this.search_Btn = true;
    this.isInputValid = false;
    this.previousValue = "";
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement?.nativeElement?.focus(), 0);
    }
  }

  search(value: any) {
    if (!value) {
      this.tripNumber = -1;
      this.fetch_page = 1;
      this.currentPage = 1;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, this.tripNumber);
      this.searchButton = true;
      this.toggleSearch = false;
      this.cancelSearchButton = false;
    } else {
      this.cancelSearchButton = true;
      this.search_Btn = false;
      this.searchButton = false;
      this.fetch_page = 1;
      this.currentPage = 1;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, value);
    }
  }

  help() {
    this.router.navigateByUrl("/?target=support");
  }
}
